import { ContactPersonDto } from 'services/APIs/InternalAPI/internal-api.contracts'
import { RootAppState } from 'store/configureStore'

export const projectBuyerContactInfoSelector = (
  state: RootAppState
): ContactPersonDto | undefined => {
  return state.project?.activeProject?.contactPerson
}
